import {
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import {HtmlEditorCkLazyComponentDefinition} from '../../../ck/html-editor-ck/html-editor-ck-lazy-component.definition';

@Component({
  selector: '<app-html-document-editor',
  templateUrl: './html-editor.component.html',
  styleUrls: ['./html-editor.component.scss']
})
export class HtmlEditorComponent {
  definition = HtmlEditorCkLazyComponentDefinition.getDefinition();
  @Input() html: string;
  @Input() customerId: number;
  @Output() htmlChange: EventEmitter<string> = new EventEmitter<string>();
  instance = this;
  onHtmlChange(html: string) {
    this.htmlChange.emit(html);
  }
}
